module.exports = __webpack_public_path__ + "img/logo-sushiset-svg.318d01be7a8a.svg";